import { render } from "./SectionAboutWelcome.vue?vue&type=template&id=0b037768&scoped=true"
import script from "./SectionAboutWelcome.vue?vue&type=script&lang=js"
export * from "./SectionAboutWelcome.vue?vue&type=script&lang=js"

import "./SectionAboutWelcome.vue?vue&type=style&index=0&id=0b037768&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b037768"]])

export default __exports__